import { storageKey } from './utils'
import type { Options } from './types'

export function getItem(key: string, options?: Options) {
  return window && typeof window !== 'undefined'
    ? window.sessionStorage.getItem(storageKey(key, options?.appGroup))
    : undefined
}

export function setItem(key: string, value: string, options?: Options) {
  return window && typeof window !== 'undefined'
    ? window.sessionStorage.setItem(storageKey(key, options?.appGroup), value)
    : undefined
}

export function deleteItem(key: string, options?: Options) {
  return window && typeof window !== 'undefined'
    ? window.sessionStorage.removeItem(storageKey(key, options?.appGroup))
    : undefined
}
